// NPM Imports
import React from "react";
import { connect } from "react-redux";
// import { Loader } from "../../../revvComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Components Imports
import MetaFieldItems from "../MetaFieldItems";

// constants imports
import { emptyImage } from "../../../constants/images";

// Actions Imports
import { deleteMetaFieldAction } from "../../../actions/MetaFieldActions";
// Internal Imports

// Destructuring

const MetaFieldListAccordion = ({
  heading,
  subHeading,
  key,
  showAccordionBody,
  selectCategory,
  totalCategories,
  metaFieldItems,
  category,
  templateObjectId,
  documentObjectId,
  deleteMetaField,
  mode,
}) => {
  const handleDeleteMetaField = metaFieldItemName => {
    const docMode = templateObjectId ? "templates" : "documents";
    const objectId = templateObjectId || documentObjectId;
    deleteMetaField(docMode, objectId, metaFieldItemName);
  };
  console.debug(metaFieldItems.length, Object.keys(metaFieldItems).length);
  return (
    <div
      className={`metafield-listaccordion-container ${
        totalCategories === 1 ? "no-bottom-border" : ""
      }`}
      key={key}>
      {/* ----- accordion header ----- */}
      <div
        className={`metafield-listaccordion-header ${
          showAccordionBody ? " active " : ""
        }`}
        onClick={selectCategory}
        onKeyPress={() => {}}
        role="button"
        tabIndex="0">
        <span className="metafield-listaccordion-heading">{heading}</span>
        <span className="metafield-listaccordion-subtext">
          {Object.keys(metaFieldItems).length}
        </span>
        <FontAwesomeIcon
          icon={["far", showAccordionBody ? "angle-up" : "angle-down"]}
          className="metafield-listaccordion-indicator-icon"
        />
      </div>
      {/* ----- accordion body ----- */}
      {showAccordionBody && (
        <div className="metafield-listaccordion-body">
          <span className="metafield-listaccordion-subheading">
            {subHeading}
          </span>

          {Object.keys(metaFieldItems).length > 0 ? (
            <MetaFieldItems
              metaFieldItems={metaFieldItems}
              category={category}
              handleDeleteMetaField={handleDeleteMetaField}
            />
          ) : (
            <span>
              <img
                src={emptyImage}
                alt="empty-metatags"
                className="metafield-info-img"
              />
              <div className="metafield-info-note">
                {`Nothing added here yet! Create new ${
                  mode === "DOCUMENT" && category.level === "TEMPLATE"
                    ? "document"
                    : ""
                } metafield above`}
              </div>
            </span>
          )}
        </div>
      )}
      <hr className="metafield-listaccordion-container-border" />
    </div>
  );
};

const mapStateToProps = state => {
  const {
    customDynamicFieldData,
    template: { object_id: templateObjectId },
  } = state.TemplateStore;
  const {
    document: { objectId: documentObjectId },
  } = state.DocumentStore;
  return {
    customDynamicFieldData,
    templateObjectId,
    documentObjectId,
  };
};

const mapDispatchToProps = {
  deleteMetaField: deleteMetaFieldAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MetaFieldListAccordion);
